import {PspEvaPermission, PspLillyPermission, PspRochePermission} from '../../_constants/permissions.constant';
import {RouteInfo} from '@components/sidebar/sidebar.component';

export const MenuItems: RouteInfo[] = [
  {
    path: '/offers',
    title: 'Offers',
    type: 'link',
    icontype: 'ni-shop text-primary',
  },
  {
    path: '/prescription-fulfillments',
    title: 'Prescription Fulfillment',
    type: 'sub',
    icontype: 'fulfillment-side-menu-icon',
    collapse: 'Prescription Fulfillment',
    isCollapsed: true,
    children: [
      {
        path: 'medicine',
        title: 'Medicine',
        type: 'link',
      },
      {
        path: 'labtest',
        title: 'Lab Test',
        type: 'link',
      },
      {
        path: 'radiology',
        title: 'Radiology',
        type: 'link',
      },
      {
        path: 'procedure',
        title: 'Procedure',
        type: 'link',
      },
    ],
  },
  {
    path: '/services',
    title: 'Services',
    type: 'link',
    icontype: 'ni-bullet-list-67 text-orange',
    permission: 'Services'
  },
  {
    path: '/geo',
    title: 'Geographical Information',
    type: 'sub',
    icontype: 'ni-square-pin text-pink',
    collapse: 'geo',
    isCollapsed: true,
    permission: 'Cities',
    children: [
      { path: 'cities', title: 'Cities', type: 'link' },
      { path: 'areas', title: 'Areas', type: 'link' },
    ],
  },
  {
    path: '/',
    title: 'Tests & Labs',
    type: 'sub',
    icontype: 'ni-building text-primary',
    collapse: 'test',
    isCollapsed: true,
    permission: 'Labs',
    children: [
      { path: 'tests', title: 'Tests', type: 'link' },
      { path: 'centers', title: 'Labs & Radiology Centers', type: 'link' },
      { path: 'test-request', title: 'Test Requests', type: 'link', permission: 'Test Requests' },
    ],
  },
  {
    path: '/appointments',
    title: 'Appointments',
    type: 'sub',
    icontype: 'fa fa-calendar text-green',
    collapse: 'appointment',
    isCollapsed: true,
    permission: 'All Appointment',
    children: [
      {
        path: 'allappointments',
        title: 'All Appointments',
        type: 'link',
      },
      {
        path: 'liveappointments',
        title: 'Live Appointments',
        type: 'link',
        permission: 'Live Appointment'
      },
    ],
  },
  {
    path: 'specialties',
    title: 'Specialties',
    type: 'link',
    icontype: 'fas fa-user-md text-pink',
    permission: 'Doctor Specialities'
  },
  {
    path: '/coupons',
    title: 'Coupons',
    type: 'link',
    icontype: 'ni ni-credit-card text-purple',
    permission: 'Coupons'
  },
  {
    path: '/faqs',
    title: 'FAQs',
    type: 'link',
    icontype: 'ni ni-ruler-pencil text-primary',
    permission: 'FAQ'
  },

  {
    path: '/push-notifications',
    title: 'Push Notifications',
    type: 'link',
    icontype: 'ni-building text-primary',
    permission: 'Push Notification'
  },
  {
    path: 'https://api.limitlesscare.com/AdminUser/LoginUser',
    title: 'Add Doctor',
    type: 'outer-link',
    icontype: 'ni-square-pin text-pink',
  },
  {
    path: 'patients',
    title: 'Limitless Care Patients',
    type: 'link',
    icontype: 'patient-side-menu-icon text-info',
    permission: 'Patients'
  },
  {
    path: '/lca-patients',
    title: 'LCA Patients',
    type: 'link-image',
    icontype: '../../../assets/lca-icon.svg',
  },
  {
    path: '/emergency-patients',
    title: 'Emergency Patients',
    type: 'link',
    icontype: 'ni-user-run text-danger',
    permission: 'Emergency Patients'
  },
  {
    path: '/emergency-management',
    title: 'Emergency Management',
    type: 'link',
    icontype: 'ni-user-run text-success',
    permission: 'Emergency Card'
  },
  {
    path: '/emergency-card',
    title: 'Emergency Card',
    type: 'link',
    icontype: 'ni-user-run text-success',
    permission: 'Emergency Card'
  },
  {
    path: '/psp',
    title: 'PSP',
    type: 'sub',
    icontype: 'ni-sound-wave text-green',
    collapse: 'psp',
    isCollapsed: true,
    permission: [ // permissions between them OR relationship
      PspEvaPermission,
      PspLillyPermission,
      PspRochePermission
    ],
    children: [
      {
        path: 'daily-tasks',
        title: 'Daily Tasks',
        type: 'link',
      },
      {
        path: 'psp-patients',
        title: 'PSP Patients',
        type: 'link',
        permission: 'PSP Subscriptions',
      },
      {
        path: 'medication',
        isCollapsed: true,
        title: 'Medication Requests',
        type: 'sub',
        collapse: 'multilevel',
        permission: 'Psp Medication Requests',
        children: [
          { title: 'Home Delivery', path: 'home-delivery', type: 'link' },
          { title: 'Pickup', path: 'pick-up', type: 'link' },
        ],
      },
      {
        path: 'pharmacies',
        title: 'Pharmacies',
        type: 'link',
        permission: PspEvaPermission
      },
      {
        path: 'my-jounery-beyond-weight',
        title: 'My Journey Beyond Weight',
        type: 'link',
        permission: PspLillyPermission
      },
      {
        path: 'finglodine-subscriptions',
        title: 'Finglodine Subscriptions',
        type: 'link',
      },
    ],
  },
  {
    path: '/uploading-tool',
    title: 'Uploading Tool',
    type: 'link-image',
    icontype: '../../../assets/prescription-icon.svg',
  },
];
